import styled from 'styled-components';
export const Results = styled.div `
  background-color: white;
  min-height: 5rem;
  color: #444;
  padding: 3rem 1.5rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  
  .search-swiper {
    flex-grow: 1;
  }
  
  .view-all {
    align-self: center;
    margin-top: 2rem;
  }
`;
export const Element = styled.div `
  //padding: 3rem 1.5rem 1rem;
  color: white;
`;
export const LoadingWrapper = styled.div `
  position: absolute;
  top: 0;
  padding-top: 5rem;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 2;
`;
export default {
    Element,
    Results,
    LoadingWrapper,
};
